<template>
  <div class="timer-log-container">
    <div class="timer-log-table-container">
      <p v-for="user in task.task_time_duration" :key="user.user_id">
        <strong> {{ user.user.full_name }} - {{ user.time }}</strong>
      </p>
      <!--      <p v-for="user in totalTime" :key="user.id">-->
      <!--        <strong> {{ user.user.full_name }} - {{ user.totalTime }}</strong>-->
      <!--      </p>-->

      <table class="table timer-log-table">
        <tbody>
          <tr
            v-if="!showHistory"
            v-for="(log, idx) in task.task_time_duration_log.slice(0, 4)"
            :key="log.id"
          >
            <td>
              {{
                idx == task.task_time_duration_log.length - 1
                  ? "Create"
                  : btnTitle(log)
              }}
            </td>
            <td>{{ log.timer.user.full_name | truncate(12) }}</td>
            <td>{{ log.time }}</td>
            <td>{{ formatDate(log.updated_at) }}</td>
          </tr>
          <tr
            v-if="showHistory"
            v-for="log in task.task_time_duration_log"
            :key="log.id"
          >
            <td>{{ btnTitle(log) }}</td>
            <td>{{ log.timer.user.full_name | truncate(12) }}</td>
            <td>{{ log.time }}</td>
            <td>{{ formatDate(log.updated_at) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <button
      v-if="task.task_time_duration_log.length > 4"
      @click="showHistory = !showHistory"
      class="history-btn"
    >
      {{ showHistory ? "Less" : "Expand" }}
    </button>
    <!--    <table class="table timer-log-table-history" v-if="showHistory">-->
    <!--      <tbody>-->
    <!--        <tr v-for="log in timerLog.slice(4, timerLog.length)" :key="log.id">-->
    <!--          <td>Read</td>-->
    <!--          <td>{{ log.timer.user.full_name }}</td>-->
    <!--          <td>{{ log.time }}</td>-->
    <!--        </tr>-->
    <!--      </tbody>-->
    <!--    </table>-->
  </div>
</template>

<script>
import apiClientCreator from "../../../helpers/api/request";
import moment from "moment";
import { mapGetters, mapState } from "vuex";

export default {
  name: "TimerLog",
  props: {
    task: {
      type: Object
    }
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"])
  },
  data() {
    return {
      totalTime: [],
      timerLog: [],
      showHistory: false
    };
  },
  beforeMount() {
    // this.getTimerLog();
  },
  methods: {
    formatDate(date) {
      return moment(String(date)).format("DD/MM/YY HH:mm");
    },

    fTime(time) {
      return moment(time).format("hh:m");
    },
    fDate(time) {
      return moment(time).format("DD/M");
    },
    btnTitle(log) {
      if (log.user_id !== this.auth.user.id) {
        return "WIP";
      } else {
        return "Read";
      }

      // let timer = timeDuration.find(item => {
      //     return item.user_id == this.auth.user.id;
      // });
      // if(timer.running == 0){
      //     return "Read"
      // } else{
      //     return "WIP"
      // }
      // return "dsf"
    },
    // isTaskExecutor() {
    //     let isTaskExecutor = false;
    //     this.task.task_assignment.forEach(assign => {
    //         if (assign.assigned_to.id === this.auth.user.id) {
    //             isTaskExecutor = true;
    //         }
    //     });

    //     return isTaskExecutor;
    // },
    // async getTimerLog() {
    //   try {
    //     const addNewClientRequest = apiClientCreator(
    //       `tasks/time/log/${this.task.id}`
    //     );
    //
    //     const response = await addNewClientRequest.get("");
    //     this.totalTime.push({
    //       user: response.data[0].timer.user,
    //       totalTime: "00:00:00"
    //     });
    //
    //     response.data.forEach(resItem => {
    //       this.totalTime.forEach(totalItem => {
    //         if (totalItem.user.id !== resItem.user_id) {
    //           this.totalTime.push({
    //             user: resItem.timer.user,
    //             totalTime: "00:00:00"
    //           });
    //         }
    //       });
    //     });
    //
    //     this.totalTime.forEach(item => {
    //       response.data.forEach(resItem => {
    //         if (item.user.id === resItem.user_id) {
    //           item.totalTime = moment
    //             .duration(item.totalTime)
    //             .add(moment.duration(resItem.time));
    //         }
    //       });
    //     });
    //
    //     this.totalTime.forEach(item => {
    //       item.totalTime = moment
    //         .utc(item.totalTime.asMilliseconds())
    //         .format("HH:mm:ss");
    //     });
    //
    //     // let tempTotalTime = '00:00:00'
    //     // response.data.forEach(item=>{
    //     //   tempTotalTime = moment.duration(tempTotalTime).add(moment.duration(item.time))
    //     //
    //     //   // tempTotalTime += moment(item.time,'HH:mm:ss').add(1, 'seconds').format('HH:mm:ss')
    //     // })
    //     // this. totalTime = tempTotalTime
    //
    //     this.timerLog = response.data;
    //     let unique = www.txt.uniqBy(this.totalTime, function (e) {
    //       return e.user.id;
    //     });
    //     this.totalTime = unique
    //   } catch (e) {}
    // }
    async getTimerLog() {
      try {
        const addNewClientRequest = apiClientCreator(
          `tasks/time/log/${this.task.id}`
        );

        const response = await addNewClientRequest.get("");
        this.timerLog = response.data;
        //
        // this.totalTime.push({
        //   user: response.data[0].timer.user,
        //   totalTime: "00:00:00"
        // });
        //
        // response.data.forEach(resItem => {
        //   this.totalTime.forEach(totalItem => {
        //     if (totalItem.user.id !== resItem.user_id) {
        //       this.totalTime.push({
        //         user: resItem.timer.user,
        //         totalTime: "00:00:00"
        //       });
        //     }
        //   });
        // });
        //
        // this.totalTime.forEach(item => {
        //   response.data.forEach(resItem => {
        //     if (item.user.id === resItem.user_id) {
        //       item.totalTime = moment
        //         .duration(item.totalTime)
        //         .add(moment.duration(resItem.time));
        //     }
        //   });
        // });
        //
        // this.totalTime.forEach(item => {
        //   item.totalTime = moment
        //     .utc(item.totalTime.asMilliseconds())
        //     .format("HH:mm:ss");
        // });

        // let tempTotalTime = '00:00:00'
        // response.data.forEach(item=>{
        //   tempTotalTime = moment.duration(tempTotalTime).add(moment.duration(item.time))
        //
        //   // tempTotalTime += moment(item.time,'HH:mm:ss').add(1, 'seconds').format('HH:mm:ss')
        // })
        // this. totalTime = tempTotalTime

        // let unique = www.txt.uniqBy(this.totalTime, function (e) {
        //   return e.user.id;
        // });
        // this.totalTime = unique
      } catch (e) {}
    }
  }
};
</script>

<style scoped>
.timer-log-container {
  height: 100%;
  margin-top: 9px;
  width: 270px;
  /*overflow-x: visible;*/
  font-size: 10px;
}

.timer-log-table-container {
  height: 90%;
  /*margin-top: 9px;*/
  /*width: max-content;*/
  /*overflow-y: scroll; */
  overflow-y: auto;
  font-size: 10px;
}

.table > tbody > tr > td,
.table > tbody > tr > th,
.table > tfoot > tr > td,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > thead > tr > th {
  padding: 4px;
  line-height: 1.42857143;
  vertical-align: top;
  border-top: 1px solid #ddd;
}
.timer-log-table-history {
  position: absolute;
  /*width: auto;*/
  width: 210px;
}
.history-btn {
  font-family: Montserrat;
  height: 20px;
  background: #44a2d2;
  color: white;
  border: 0;
  padding: 5px;
  font-size: 10px;
  cursor: pointer;
  margin-left: 10px;
  margin-top: 2px;
  margin-bottom: 5px;
  line-height: 10px;
}
.timer-log-table {
  margin-bottom: 5px;
}
</style>
